import cx from 'classnames';
import * as React from 'react';

import './styles/MediaObject.scss';

type FigureValues = 'left' | 'right';

function wrapChildren(
  firstChild: React.ReactNode,
  lastChild: React.ReactNode,
  figure?: FigureValues
) {
  const wrappedFirstChild = (
    <div className={`MediaObject-${figure === 'left' ? 'figure' : 'body'}`}>{firstChild}</div>
  );
  const wrappedLastChild = (
    <div className={`MediaObject-${figure === 'left' ? 'body' : 'figure'}`}>{lastChild}</div>
  );

  return [wrappedFirstChild, wrappedLastChild];
}

export type MediaObjectGutter =
  | 'xxxxxlarge'
  | 'xxxxlarge'
  | 'medium'
  | 'small'
  | 'xsmall'
  | 'xxsmall';

export type Props = {
  center?: boolean;
  bottom?: boolean;
  children: [React.ReactNode, React.ReactNode];
  className?: string;
  figure?: FigureValues;
  gutter?: MediaObjectGutter;
  inline?: boolean;
  baseline?: boolean
};

export default class MediaObject extends React.Component<Props> {
  static defaultProps = {
    figure: 'left',
    gutter: 'large',
  };

  render() {
    const { bottom, center, children, className, figure, gutter, inline, baseline } = this.props;

    const [firstChild, lastChild] = children;
    const [leftChild, rightChild] = wrapChildren(firstChild, lastChild, figure);

    return (
      <div
        className={cx(
          'MediaObject',
          baseline && `MediaObject--baseline`,
          bottom && `MediaObject--bottom`,
          center && `MediaObject--center`,
          gutter && `MediaObject--${gutter}`,
          inline && `MediaObject--inline`,
          className
        )}>
        {leftChild}
        {rightChild}
      </div>
    );
  }
}
